export default __webpack_public_path__ + "static/media/800.a5ee39f5.png";